
// import React, { useEffect, useMemo, useState } from "react";
// import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
// import MarkerClusterGroup from "react-leaflet-cluster";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";

// import "./jobs_map_view.css";
// import {
//   getJobMap,
//   getJobInspectionPhotos,
// } from "../services/jobMapService";

// // Standard status to color map for Leaflet circle markers
// const STATUS_COLORS = {
//   completed: "#35d39b",
//   active: "#4d8dff",
//   pending: "#f5b84b",
//   rejected: "#ff6b72",
//   cancelled: "#8b949e",
// };

// // Helper component to adjust bounds dynamically when points load
// const AutoFitBounds = ({ points }) => {
//   const map = useMap();

//   useEffect(() => {
//     if (points && points.length > 0) {
//       const validLatLngs = points
//         .filter((p) => typeof p.lat === "number" && typeof p.long === "number")
//         .map((p) => [p.lat, p.long]);

//       if (validLatLngs.length > 0) {
//         const bounds = L.latLngBounds(validLatLngs);
//         map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
//       }
//     }
//   }, [points, map]);

//   return null;
// };

// // Custom cluster icon builder
// const createCustomClusterIcon = (cluster) => {
//   const count = cluster.getChildCount();
//   return L.divIcon({
//     html: `<div>${count}</div>`,
//     className: "custom-cluster-marker",
//     iconSize: L.point(35, 35, true),
//   });
// };

// export const JobsMapView = () => {
//   const [data, setData] = useState({ total: 0, points: [] });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState("all");
//   const [showLegend, setShowLegend] = useState(true);

//   const [photoPanelOpen, setPhotoPanelOpen] = useState(false);
//   const [selectedPhotoJob, setSelectedPhotoJob] = useState(null);
//   const [inspectionPhotos, setInspectionPhotos] = useState([]);
//   const [photosLoading, setPhotosLoading] = useState(false);
//   const [photosError, setPhotosError] = useState(null);
//   const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(null);

//   const loadData = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const res = await getJobMap();
//       setData(res || { total: 0, points: [] });
//     } catch (err) {
//       setError("Failed to load job map points.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadData();
//   }, []);

//   const handleViewPhotos = async (point) => {
//     try {
//       setSelectedPhotoJob(point);
//       setPhotoPanelOpen(true);
//       setPhotosLoading(true);
//       setPhotosError(null);
//       setInspectionPhotos([]);

//       const result = await getJobInspectionPhotos(point.id);

//       const photos =
//         result?.images ||
//         result?.photos ||
//         result?.data ||
//         [];

//       setInspectionPhotos(
//         Array.isArray(photos) ? photos : []
//       );
//     } catch (err) {
//       console.error("Failed to load inspection photos:", err);

//       setPhotosError(
//         err?.response?.data?.detail ||
//         err?.message ||
//         "Failed to load inspection photos."
//       );
//     } finally {
//       setPhotosLoading(false);
//     }
//   };

//   const handleOpenPhoto = (index) => {
//     setSelectedPhotoIndex(index);
//   };

//   const handleClosePhotoViewer = () => {
//     setSelectedPhotoIndex(null);
//   };

//   const handlePreviousPhoto = () => {
//     setSelectedPhotoIndex((currentIndex) => {
//       if (currentIndex === null || inspectionPhotos.length === 0) {
//         return currentIndex;
//       }

//       return currentIndex === 0
//         ? inspectionPhotos.length - 1
//         : currentIndex - 1;
//     });
//   };

//   const handleNextPhoto = () => {
//     setSelectedPhotoIndex((currentIndex) => {
//       if (currentIndex === null || inspectionPhotos.length === 0) {
//         return currentIndex;
//       }

//       return currentIndex === inspectionPhotos.length - 1
//         ? 0
//         : currentIndex + 1;
//     });
//   };

//   const handleClosePhotoPanel = () => {
//     setPhotoPanelOpen(false);
//     setSelectedPhotoJob(null);
//     setInspectionPhotos([]);
//     setPhotosError(null);
//     setSelectedPhotoIndex(null);
//   };

//   // Filter calculations
//   const filteredPoints = useMemo(() => {
//     return data.points.filter((point) => {
//       // 1. Status Filter
//       if (selectedStatus !== "all") {
//         if (point.marker_type !== selectedStatus) {
//           return false;
//         }
//       }

//       // 2. Text Search Filter (title, snap_job_id, id, location address/description)
//       if (searchTerm.trim() !== "") {
//         const term = searchTerm.toLowerCase();
//         const title = (point.title || "").toLowerCase();
//         const snapJobId = (point.snap_job_id || "").toLowerCase();
//         const idStr = String(point.id);
//         const address = (point.location?.address || "").toLowerCase();
//         const description = (point.location?.description || "").toLowerCase();

//         return (
//           title.includes(term) ||
//           snapJobId.includes(term) ||
//           idStr.includes(term) ||
//           address.includes(term) ||
//           description.includes(term)
//         );
//       }

//       return true;
//     });
//   }, [data.points, selectedStatus, searchTerm]);

//   // KPI Calculations
//   const kpis = useMemo(() => {
//     const counts = {
//       mapped: data.points.length,
//       completed: 0,
//       active: 0,
//       pending: 0,
//       rejected: 0,
//     };

//     data.points.forEach((p) => {
//       if (p.marker_type === "completed") counts.completed++;
//       else if (p.marker_type === "active") counts.active++;
//       else if (p.marker_type === "pending") counts.pending++;
//       else if (p.marker_type === "rejected") counts.rejected++;
//     });

//     return counts;
//   }, [data.points]);

//   const excludedCount = data.points.length - filteredPoints.length;

//   return (
//     <div className="jobs-map-container">
//       {/* Header */}
//       <div className="jobs-map-header">
//         <h1 className="jobs-map-title">Job Coverage Map</h1>

//         <div className="jobs-map-toolbar">
//           <div className="jobs-map-toolbar-left">
//             <select
//               className="jobs-map-select-filter"
//               value={selectedStatus}
//               onChange={(e) => setSelectedStatus(e.target.value)}
//             >
//               <option value="all">All Statuses</option>
//               <option value="completed">Completed</option>
//               <option value="active">Active</option>
//               <option value="pending">Pending</option>
//               <option value="rejected">Rejected</option>
//               <option value="cancelled">Cancelled</option>
//             </select>
//           </div>

//           <div className="jobs-map-toolbar-right">
//             <button
//               className="jobs-map-toggle-legend-btn"
//               onClick={() => setShowLegend(!showLegend)}
//             >
//               {showLegend ? "Hide Legend" : "Show Legend"}
//             </button>

//             <span className="jobs-map-showing-count">
//               Showing {filteredPoints.length.toLocaleString()}
//             </span>

//             <button
//               className="jobs-map-refresh-btn"
//               onClick={loadData}
//               disabled={loading}
//             >
//               ↻ {loading ? "Refreshing..." : "Refresh"}
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* KPI Cards */}
//       <div className="jobs-map-kpi-grid">
//         <div className="jobs-map-kpi-card mapped">
//           <span className="jobs-map-kpi-label">Mapped Jobs</span>
//           <span className="jobs-map-kpi-value">
//             {kpis.mapped.toLocaleString()}
//           </span>
//         </div>
//         <div className="jobs-map-kpi-card completed">
//           <span className="jobs-map-kpi-label">Completed</span>
//           <span className="jobs-map-kpi-value">
//             {kpis.completed.toLocaleString()}
//           </span>
//         </div>
//         <div className="jobs-map-kpi-card active">
//           <span className="jobs-map-kpi-label">Active</span>
//           <span className="jobs-map-kpi-value">
//             {kpis.active.toLocaleString()}
//           </span>
//         </div>
//         <div className="jobs-map-kpi-card pending">
//           <span className="jobs-map-kpi-label">Pending</span>
//           <span className="jobs-map-kpi-value">
//             {kpis.pending.toLocaleString()}
//           </span>
//         </div>
//         <div className="jobs-map-kpi-card rejected">
//           <span className="jobs-map-kpi-label">Rejected</span>
//           <span className="jobs-map-kpi-value">
//             {kpis.rejected.toLocaleString()}
//           </span>
//         </div>
//       </div>

//       {/* Map Shell */}
//       <div className="jobs-map-wrapper">
//         <MapContainer
//           center={[20.5937, 78.9629]}
//           zoom={5}
//           scrollWheelZoom={true}
//           className="jobs-map-leaflet"
//         >
//           <TileLayer
//             attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
//             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//           />

//           <AutoFitBounds points={filteredPoints} />

//           <MarkerClusterGroup
//             chunkedLoading
//             maxClusterRadius={(zoom) => {
//               if (zoom <= 7) return 70;
//               if (zoom <= 9) return 50;
//               if (zoom <= 11) return 30;
//               return 15;
//             }}
//             disableClusteringAtZoom={10}
//             spiderfyOnMaxZoom={true}
//             iconCreateFunction={createCustomClusterIcon}
//           >
//             {filteredPoints.map((point) => {
//               const markerColor =
//                 STATUS_COLORS[point.marker_type] || STATUS_COLORS.pending;

//               // Extract job content type count dynamically if present
//               let contentTypeText = "N/A";
//               if (point.job_type_data) {
//                 if (point.job_type_data.numberOfVideos) {
//                   contentTypeText = `${point.job_type_data.numberOfVideos} Videos`;
//                 } else if (point.job_type_data.numberOfPhotos) {
//                   contentTypeText = `${point.job_type_data.numberOfPhotos} Photos`;
//                 }
//               }

//               return (
//                 <CircleMarker
//                   key={point.id}
//                   center={[point.lat, point.long]}
//                   radius={5}
//                   pathOptions={{
//                     fillColor: markerColor,
//                     fillOpacity: 0.85,
//                     color: "#000000",
//                     weight: 1.5,
//                   }}
//                 >
//                   <Popup>
//                     <div className="job-popup-card">
//                       <div className="job-popup-header">
//                         <div
//                           className={`job-popup-status-indicator ${point.marker_type}`}
//                         />
//                         <div className="job-popup-title-box">
//                           <span className="job-popup-title">
//                             {point.title || "Untitled Job"}
//                           </span>
//                           <span className="job-popup-snap-id">
//                             {point.snap_job_id || `ID: ${point.id}`}
//                           </span>
//                         </div>
//                       </div>

//                       <div className="job-popup-grid">
//                         <div className="job-popup-grid-item">
//                           <span className="job-popup-grid-label">Status</span>
//                           <span className="job-popup-grid-value">
//                             {point.status || point.marker_type}
//                           </span>
//                         </div>
//                         <div className="job-popup-grid-item">
//                           <span className="job-popup-grid-label">Type</span>
//                           <span className="job-popup-grid-value">
//                             {point.type || "N/A"}
//                           </span>
//                         </div>
//                         <div className="job-popup-grid-item">
//                           <span className="job-popup-grid-label">Job ID</span>
//                           <span className="job-popup-grid-value">
//                             {point.id}
//                           </span>
//                         </div>
//                         <div className="job-popup-grid-item">
//                           <span className="job-popup-grid-label">Content</span>
//                           <span className="job-popup-grid-value">
//                             {contentTypeText}
//                           </span>
//                         </div>
//                       </div>

//                       {point.location && (
//                         <div className="job-popup-location-box">
//                           <span className="job-popup-location-label">
//                             Location
//                           </span>
//                           <span className="job-popup-location-text">
//                             {point.location.description ||
//                               point.location.address ||
//                               "Address not provided"}
//                           </span>
//                         </div>
//                       )}

//                       <div className="job-popup-actions">
//                         <button
//                           type="button"
//                           className="job-popup-action-btn"
//                           onClick={() =>
//                             window.open(
//                             `/job-detail-test/${point.id}`,
//                               "_blank",
//                               "noopener,noreferrer"
//                             )
//                           }
//                         >
//                           View Job →
//                         </button>

//                         <button
//                           type="button"
//                           className="job-popup-photo-btn"
//                           onClick={() => handleViewPhotos(point)}
//                         >
//                           📷 View Inspection Photos
//                         </button>
//                       </div>
//                     </div>
//                   </Popup>
//                 </CircleMarker>
//               );
//             })}
//           </MarkerClusterGroup>
//         </MapContainer>

//         {/* Legend */}
//         {showLegend && (
//           <div className="jobs-map-legend">
//             <div className="jobs-map-legend-title">Job Status</div>
//             <div className="jobs-map-legend-items">
//               <div className="jobs-map-legend-item">
//                 <span className="jobs-map-dot completed" /> Completed
//               </div>
//               <div className="jobs-map-legend-item">
//                 <span className="jobs-map-dot active" /> Active
//               </div>
//               <div className="jobs-map-legend-item">
//                 <span className="jobs-map-dot pending" /> Pending
//               </div>
//               <div className="jobs-map-legend-item">
//                 <span className="jobs-map-dot rejected" /> Rejected
//               </div>
//               <div className="jobs-map-legend-item">
//                 <span className="jobs-map-dot cancelled" /> Cancelled
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Dataset Badge */}
//         <div className="jobs-map-live-badge">
//           <span className="jobs-map-live-dot" /> Live job dataset
//         </div>
//       </div>

//       {/* Photo Drawer */}
//       {photoPanelOpen && (
//         <div className="job-photo-drawer">
//           <div className="job-photo-drawer-header">
//             <div>
//               <div className="job-photo-drawer-eyebrow">
//                 Inspection Photos
//               </div>

//               <h2 className="job-photo-drawer-title">
//                 {selectedPhotoJob?.title || "Job Photos"}
//               </h2>

//               <div className="job-photo-drawer-job-id">
//                 {selectedPhotoJob?.location?.description ||
//                   selectedPhotoJob?.location?.address ||
//                   "Address not provided"}
//               </div>
//             </div>

//             <button
//               type="button"
//               className="job-photo-drawer-close"
//               onClick={handleClosePhotoPanel}
//               aria-label="Close photos"
//             >
//               ×
//             </button>
//           </div>

//           <div className="job-photo-drawer-body">
//             {photosLoading && (
//               <div className="job-photo-state">
//                 <div className="job-photo-spinner" />
//                 <span>Loading inspection photos...</span>
//               </div>
//             )}

//             {!photosLoading && photosError && (
//               <div className="job-photo-state job-photo-error">
//                 <div className="job-photo-error-icon">
//                   !
//                 </div>

//                 <div>
//                   <strong>Unable to load photos</strong>
//                   <p>{photosError}</p>
//                 </div>
//               </div>
//             )}

//             {!photosLoading &&
//               !photosError &&
//               inspectionPhotos.length === 0 && (
//                 <div className="job-photo-state">
//                   <div className="job-photo-empty-icon">
//                     📷
//                   </div>

//                   <strong>No inspection photos found</strong>

//                   <span>
//                     No photos are available for this job.
//                   </span>
//                 </div>
//               )}

//             {!photosLoading &&
//               !photosError &&
//               inspectionPhotos.length > 0 && (
//                 <div className="job-photo-grid">
//                   {inspectionPhotos.map((photo, index) => {
//                     const photoUrl =
//                       typeof photo === "string"
//                         ? photo
//                         : photo?.url ||
//                           photo?.fileUrl ||
//                           photo?.image_url;

//                     if (!photoUrl) {
//                       return null;
//                     }

//                     return (
//                       <div
//                         className="job-photo-card"
//                         key={`${photoUrl}-${index}`}
//                         onClick={() => handleOpenPhoto(index)}
//                         role="button"
//                         tabIndex={0}
//                         onKeyDown={(e) => {
//                           if (e.key === "Enter" || e.key === " ") {
//                             handleOpenPhoto(index);
//                           }
//                         }}
//                       >
//                         <img
//                           src={photoUrl}
//                           alt={`Inspection ${index + 1}`}
//                           className="job-photo-image"
//                           loading="lazy"
//                         />

//                         <div className="job-photo-number">
//                           {index + 1}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               )}
//           </div>
//         </div>
//       )}

//       {/* Full-Screen Lightbox Viewer */}
//       {selectedPhotoIndex !== null &&
//         inspectionPhotos[selectedPhotoIndex] && (
//           <div
//             className="job-photo-lightbox"
//             onClick={handleClosePhotoViewer}
//           >
//             <button
//               type="button"
//               className="job-photo-lightbox-close"
//               onClick={handleClosePhotoViewer}
//               aria-label="Close image viewer"
//             >
//               ×
//             </button>

//             <button
//               type="button"
//               className="job-photo-lightbox-prev"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handlePreviousPhoto();
//               }}
//               aria-label="Previous image"
//             >
//               ‹
//             </button>

//             <div
//               className="job-photo-lightbox-content"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {(() => {
//                 const photo = inspectionPhotos[selectedPhotoIndex];

//                 const photoUrl =
//                   typeof photo === "string"
//                     ? photo
//                     : photo?.url ||
//                       photo?.fileUrl ||
//                       photo?.image_url;

//                 return (
//                   <img
//                     src={photoUrl}
//                     alt={`Inspection ${selectedPhotoIndex + 1}`}
//                     className="job-photo-lightbox-image"
//                   />
//                 );
//               })()}

//               <div className="job-photo-lightbox-counter">
//                 {selectedPhotoIndex + 1} / {inspectionPhotos.length}
//               </div>
//             </div>

//             <button
//               type="button"
//               className="job-photo-lightbox-next"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleNextPhoto();
//               }}
//               aria-label="Next image"
//             >
//               ›
//             </button>
//           </div>
//         )}

//       {/* Footer */}
//       <div className="jobs-map-footer">
//         <span>{excludedCount} jobs are outside the selected filter.</span>
//         <span className="jobs-map-footer-note">
//           Jobs without valid latitude/longitude coordinates are excluded.
//         </span>
//       </div>
//     </div>
//   );
// };

// export default JobsMapView;

import React, { useEffect, useMemo, useRef, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import "./jobs_map_view.css";
import {
  getJobMap,
  getJobInspectionPhotos,
} from "../services/jobMapService";

// Standard status to color map for Leaflet circle markers
const STATUS_COLORS = {
  completed: "#35d39b",
  active: "#4d8dff",
  pending: "#f5b84b",
  rejected: "#ff6b72",
  cancelled: "#8b949e",
};

// Auto-adjust Leaflet canvas size on layout/resizing changes
const MapResizeObserver = () => {
  const map = useMap();

  useEffect(() => {
    const container = map.getContainer();
    if (!container) return;

    const resizeObserver = new ResizeObserver(() => {
      map.invalidateSize();
    });

    resizeObserver.observe(container);

    return () => {
      resizeObserver.disconnect();
    };
  }, [map]);

  return null;
};

// Helper component to adjust bounds dynamically when points load
const AutoFitBounds = ({ points }) => {
  const map = useMap();

  useEffect(() => {
    if (points && points.length > 0) {
      const validLatLngs = points
        .filter((p) => typeof p.lat === "number" && typeof p.long === "number")
        .map((p) => [p.lat, p.long]);

      if (validLatLngs.length > 0) {
        const bounds = L.latLngBounds(validLatLngs);
        map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
      }
    }
  }, [points, map]);

  return null;
};

// Custom cluster icon builder
const createCustomClusterIcon = (cluster) => {
  const count = cluster.getChildCount();
  return L.divIcon({
    html: `<div>${count}</div>`,
    className: "custom-cluster-marker",
    iconSize: L.point(35, 35, true),
  });
};

export const JobsMapView = () => {
  const [data, setData] = useState({ total: 0, points: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [showLegend, setShowLegend] = useState(true);

  const [photoPanelOpen, setPhotoPanelOpen] = useState(false);
  const [selectedPhotoJob, setSelectedPhotoJob] = useState(null);
  const [inspectionPhotos, setInspectionPhotos] = useState([]);
  const [photosLoading, setPhotosLoading] = useState(false);
  const [photosError, setPhotosError] = useState(null);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(null);

  const loadData = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await getJobMap();
      setData(res || { total: 0, points: [] });
    } catch (err) {
      setError("Failed to load job map points.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleViewPhotos = async (point) => {
    try {
      setSelectedPhotoJob(point);
      setPhotoPanelOpen(true);
      setPhotosLoading(true);
      setPhotosError(null);
      setInspectionPhotos([]);

      const result = await getJobInspectionPhotos(point.id);

      const photos =
        result?.images ||
        result?.photos ||
        result?.data ||
        [];

      setInspectionPhotos(
        Array.isArray(photos) ? photos : []
      );
    } catch (err) {
      console.error("Failed to load inspection photos:", err);

      setPhotosError(
        err?.response?.data?.detail ||
        err?.message ||
        "Failed to load inspection photos."
      );
    } finally {
      setPhotosLoading(false);
    }
  };

  const handleOpenPhoto = (index) => {
    setSelectedPhotoIndex(index);
  };

  const handleClosePhotoViewer = () => {
    setSelectedPhotoIndex(null);
  };

  const handlePreviousPhoto = () => {
    setSelectedPhotoIndex((currentIndex) => {
      if (currentIndex === null || inspectionPhotos.length === 0) {
        return currentIndex;
      }

      return currentIndex === 0
        ? inspectionPhotos.length - 1
        : currentIndex - 1;
    });
  };

  const handleNextPhoto = () => {
    setSelectedPhotoIndex((currentIndex) => {
      if (currentIndex === null || inspectionPhotos.length === 0) {
        return currentIndex;
      }

      return currentIndex === inspectionPhotos.length - 1
        ? 0
        : currentIndex + 1;
    });
  };

  const handleClosePhotoPanel = () => {
    setPhotoPanelOpen(false);
    setSelectedPhotoJob(null);
    setInspectionPhotos([]);
    setPhotosError(null);
    setSelectedPhotoIndex(null);
  };

  // Filter calculations
  const filteredPoints = useMemo(() => {
    return (data.points || []).filter((point) => {
      // 1. Status Filter
      if (selectedStatus !== "all") {
        if (point.marker_type !== selectedStatus) {
          return false;
        }
      }

      // 2. Text Search Filter
      if (searchTerm.trim() !== "") {
        const term = searchTerm.toLowerCase();
        const title = (point.title || "").toLowerCase();
        const snapJobId = (point.snap_job_id || "").toLowerCase();
        const idStr = String(point.id || "");
        const address = (point.location?.address || "").toLowerCase();
        const description = (point.location?.description || "").toLowerCase();

        return (
          title.includes(term) ||
          snapJobId.includes(term) ||
          idStr.includes(term) ||
          address.includes(term) ||
          description.includes(term)
        );
      }

      return true;
    });
  }, [data.points, selectedStatus, searchTerm]);

  // KPI Calculations
  const kpis = useMemo(() => {
    const counts = {
      mapped: (data.points || []).length,
      completed: 0,
      active: 0,
      pending: 0,
      rejected: 0,
    };

    (data.points || []).forEach((p) => {
      if (p.marker_type === "completed") counts.completed++;
      else if (p.marker_type === "active") counts.active++;
      else if (p.marker_type === "pending") counts.pending++;
      else if (p.marker_type === "rejected") counts.rejected++;
    });

    return counts;
  }, [data.points]);

  const excludedCount = (data.points || []).length - filteredPoints.length;

  return (
    <div className="jobs-map-container">
      {/* Header */}
      <div className="jobs-map-header">
        <div>
          <div className="jobs-map-eyebrow">Coverage & Field Analytics</div>
          <h1 className="jobs-map-title">Job Coverage Map</h1>
        </div>

        <div className="jobs-map-toolbar">
          <div className="jobs-map-toolbar-left">
            <input
              type="text"
              className="jobs-map-search-input"
              placeholder="Search jobs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <select
              className="jobs-map-select-filter"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="all">All Statuses</option>
              <option value="completed">Completed</option>
              <option value="active">Active</option>
              <option value="pending">Pending</option>
              <option value="rejected">Rejected</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>

          <div className="jobs-map-toolbar-right">
            <button
              className="jobs-map-toggle-legend-btn"
              onClick={() => setShowLegend(!showLegend)}
            >
              {showLegend ? "Hide Legend" : "Show Legend"}
            </button>

            <span className="jobs-map-showing-count">
              Showing {filteredPoints.length.toLocaleString()}
            </span>

            <button
              className="jobs-map-refresh-btn"
              onClick={loadData}
              disabled={loading}
            >
              ↻ {loading ? "Refreshing..." : "Refresh"}
            </button>
          </div>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="jobs-map-kpi-grid">
        <div className="jobs-map-kpi-card mapped">
          <span className="jobs-map-kpi-label">Mapped Jobs</span>
          <span className="jobs-map-kpi-value">
            {kpis.mapped.toLocaleString()}
          </span>
        </div>
        <div className="jobs-map-kpi-card completed">
          <span className="jobs-map-kpi-label">Completed</span>
          <span className="jobs-map-kpi-value">
            {kpis.completed.toLocaleString()}
          </span>
        </div>
        <div className="jobs-map-kpi-card active">
          <span className="jobs-map-kpi-label">Active</span>
          <span className="jobs-map-kpi-value">
            {kpis.active.toLocaleString()}
          </span>
        </div>
        <div className="jobs-map-kpi-card pending">
          <span className="jobs-map-kpi-label">Pending</span>
          <span className="jobs-map-kpi-value">
            {kpis.pending.toLocaleString()}
          </span>
        </div>
        <div className="jobs-map-kpi-card rejected">
          <span className="jobs-map-kpi-label">Rejected</span>
          <span className="jobs-map-kpi-value">
            {kpis.rejected.toLocaleString()}
          </span>
        </div>
      </div>

      {/* Map Shell */}
      <div className="jobs-map-wrapper">
        <MapContainer
          center={[20.5937, 78.9629]}
          zoom={5}
          scrollWheelZoom={true}
          className="jobs-map-leaflet"
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <MapResizeObserver />
          <AutoFitBounds points={filteredPoints} />

          <MarkerClusterGroup
            chunkedLoading
            maxClusterRadius={(zoom) => {
              if (zoom <= 7) return 70;
              if (zoom <= 9) return 50;
              if (zoom <= 11) return 30;
              return 15;
            }}
            disableClusteringAtZoom={10}
            spiderfyOnMaxZoom={true}
            iconCreateFunction={createCustomClusterIcon}
          >
            {filteredPoints.map((point) => {
              const markerColor =
                STATUS_COLORS[point.marker_type] || STATUS_COLORS.pending;

              let contentTypeText = "N/A";
              if (point.job_type_data) {
                if (point.job_type_data.numberOfVideos) {
                  contentTypeText = `${point.job_type_data.numberOfVideos} Videos`;
                } else if (point.job_type_data.numberOfPhotos) {
                  contentTypeText = `${point.job_type_data.numberOfPhotos} Photos`;
                }
              }

              return (
                <CircleMarker
                  key={point.id}
                  center={[point.lat, point.long]}
                  radius={5}
                  pathOptions={{
                    fillColor: markerColor,
                    fillOpacity: 0.85,
                    color: "#000000",
                    weight: 1.5,
                  }}
                >
                  <Popup>
                    <div className="job-popup-card">
                      <div className="job-popup-header">
                        <div
                          className={`job-popup-status-indicator ${point.marker_type}`}
                        />
                        <div className="job-popup-title-box">
                          <span className="job-popup-title">
                            {point.title || "Untitled Job"}
                          </span>
                          <span className="job-popup-snap-id">
                            {point.snap_job_id || `ID: ${point.id}`}
                          </span>
                        </div>
                      </div>

                      <div className="job-popup-grid">
                        <div className="job-popup-grid-item">
                          <span className="job-popup-grid-label">Status</span>
                          <span className="job-popup-grid-value">
                            {point.status || point.marker_type}
                          </span>
                        </div>
                        <div className="job-popup-grid-item">
                          <span className="job-popup-grid-label">Type</span>
                          <span className="job-popup-grid-value">
                            {point.type || "N/A"}
                          </span>
                        </div>
                        <div className="job-popup-grid-item">
                          <span className="job-popup-grid-label">Job ID</span>
                          <span className="job-popup-grid-value">
                            {point.id}
                          </span>
                        </div>
                        <div className="job-popup-grid-item">
                          <span className="job-popup-grid-label">Content</span>
                          <span className="job-popup-grid-value">
                            {contentTypeText}
                          </span>
                        </div>
                      </div>

                      {point.location && (
                        <div className="job-popup-location-box">
                          <span className="job-popup-location-label">
                            Location
                          </span>
                          <span className="job-popup-location-text">
                            {point.location.description ||
                              point.location.address ||
                              "Address not provided"}
                          </span>
                        </div>
                      )}

                      <div className="job-popup-actions">
                        <button
                          type="button"
                          className="job-popup-action-btn"
                          onClick={() =>
                            window.open(
                              `/job-detail-test/${point.id}`,
                              "_blank",
                              "noopener,noreferrer"
                            )
                          }
                        >
                          View Job →
                        </button>

                        <button
                          type="button"
                          className="job-popup-photo-btn"
                          onClick={() => handleViewPhotos(point)}
                        >
                          📷 View Inspection Photos
                        </button>
                      </div>
                    </div>
                  </Popup>
                </CircleMarker>
              );
            })}
          </MarkerClusterGroup>
        </MapContainer>

        {/* Legend */}
        {showLegend && (
          <div className="jobs-map-legend">
            <div className="jobs-map-legend-title">Job Status</div>
            <div className="jobs-map-legend-items">
              <div className="jobs-map-legend-item">
                <span className="jobs-map-dot completed" /> Completed
              </div>
              <div className="jobs-map-legend-item">
                <span className="jobs-map-dot active" /> Active
              </div>
              <div className="jobs-map-legend-item">
                <span className="jobs-map-dot pending" /> Pending
              </div>
              <div className="jobs-map-legend-item">
                <span className="jobs-map-dot rejected" /> Rejected
              </div>
              <div className="jobs-map-legend-item">
                <span className="jobs-map-dot cancelled" /> Cancelled
              </div>
            </div>
          </div>
        )}

        {/* Dataset Badge */}
        <div className="jobs-map-live-badge">
          <span className="jobs-map-live-dot" /> Live job dataset
        </div>
      </div>

      {/* Photo Drawer */}
      {photoPanelOpen && (
        <div className="job-photo-drawer">
          <div className="job-photo-drawer-header">
            <div>
              <div className="job-photo-drawer-eyebrow">
                Inspection Photos
              </div>

              <h2 className="job-photo-drawer-title">
                {selectedPhotoJob?.title || "Job Photos"}
              </h2>

              <div className="job-photo-drawer-job-id">
                {selectedPhotoJob?.location?.description ||
                  selectedPhotoJob?.location?.address ||
                  "Address not provided"}
              </div>
            </div>

            <button
              type="button"
              className="job-photo-drawer-close"
              onClick={handleClosePhotoPanel}
              aria-label="Close photos"
            >
              ×
            </button>
          </div>

          <div className="job-photo-drawer-body">
            {photosLoading && (
              <div className="job-photo-state">
                <div className="job-photo-spinner" />
                <span>Loading inspection photos...</span>
              </div>
            )}

            {!photosLoading && photosError && (
              <div className="job-photo-state job-photo-error">
                <div className="job-photo-error-icon">!</div>
                <div>
                  <strong>Unable to load photos</strong>
                  <p>{photosError}</p>
                </div>
              </div>
            )}

            {!photosLoading &&
              !photosError &&
              inspectionPhotos.length === 0 && (
                <div className="job-photo-state">
                  <div className="job-photo-empty-icon">📷</div>
                  <strong>No inspection photos found</strong>
                  <span>No photos are available for this job.</span>
                </div>
              )}

            {!photosLoading &&
              !photosError &&
              inspectionPhotos.length > 0 && (
                <div className="job-photo-grid">
                  {inspectionPhotos.map((photo, index) => {
                    const photoUrl =
                      typeof photo === "string"
                        ? photo
                        : photo?.url ||
                          photo?.fileUrl ||
                          photo?.image_url;

                    if (!photoUrl) return null;

                    return (
                      <div
                        className="job-photo-card"
                        key={`${photoUrl}-${index}`}
                        onClick={() => handleOpenPhoto(index)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            handleOpenPhoto(index);
                          }
                        }}
                      >
                        <img
                          src={photoUrl}
                          alt={`Inspection ${index + 1}`}
                          className="job-photo-image"
                          loading="lazy"
                        />

                        <div className="job-photo-number">
                          {index + 1}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
          </div>
        </div>
      )}

      {/* Full-Screen Lightbox Viewer */}
      {selectedPhotoIndex !== null &&
        inspectionPhotos[selectedPhotoIndex] && (
          <div
            className="job-photo-lightbox"
            onClick={handleClosePhotoViewer}
          >
            <button
              type="button"
              className="job-photo-lightbox-close"
              onClick={handleClosePhotoViewer}
              aria-label="Close image viewer"
            >
              ×
            </button>

            <button
              type="button"
              className="job-photo-lightbox-prev"
              onClick={(e) => {
                e.stopPropagation();
                handlePreviousPhoto();
              }}
              aria-label="Previous image"
            >
              ‹
            </button>

            <div
              className="job-photo-lightbox-content"
              onClick={(e) => e.stopPropagation()}
            >
              {(() => {
                const photo = inspectionPhotos[selectedPhotoIndex];

                const photoUrl =
                  typeof photo === "string"
                    ? photo
                    : photo?.url ||
                      photo?.fileUrl ||
                      photo?.image_url;

                return (
                  <img
                    src={photoUrl}
                    alt={`Inspection ${selectedPhotoIndex + 1}`}
                    className="job-photo-lightbox-image"
                  />
                );
              })()}

              <div className="job-photo-lightbox-counter">
                {selectedPhotoIndex + 1} / {inspectionPhotos.length}
              </div>
            </div>

            <button
              type="button"
              className="job-photo-lightbox-next"
              onClick={(e) => {
                e.stopPropagation();
                handleNextPhoto();
              }}
              aria-label="Next image"
            >
              ›
            </button>
          </div>
        )}

      {/* Footer */}
      <div className="jobs-map-footer">
        <span>{excludedCount} jobs are outside the selected filter.</span>
        <span className="jobs-map-footer-note">
          Jobs without valid latitude/longitude coordinates are excluded.
        </span>
      </div>
    </div>
  );
};

export default JobsMapView;